import { render, staticRenderFns } from "./servantIncome.vue?vue&type=template&id=55061669&scoped=true"
import script from "./servantIncome.vue?vue&type=script&lang=js"
export * from "./servantIncome.vue?vue&type=script&lang=js"
import style0 from "./servantIncome.vue?vue&type=style&index=0&id=55061669&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55061669",
  null
  
)

export default component.exports